import * as React from 'react';
import { Box, Card, CardContent, Typography, useMediaQuery, useTheme } from '@mui/material';

interface StatsCardProps {
  title: string;
  value: string | number;
  icon: string;
  alt: string;
}

const StatsCard: React.FC<StatsCardProps> = ({ title, value, icon, alt }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Card
      sx={{
        borderRadius: '16px',
        overflow: 'hidden',
        display: 'flex',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: { xs: '70px', sm: '90px' },
          height: '100%',
          backgroundColor: '#8884ff',
          borderRadius: '0 0 100% 0',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          p: 1.5,
        }}
      >
        <img
          src={icon}
          alt={alt}
          style={{
            width: isSmallScreen ? '40px' : '50px',
            height: isSmallScreen ? '40px' : '50px',
            color: 'white',
            alignSelf: 'flex-start',
          }}
        />
      </Box>
      <CardContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          p: 2,
          backgroundColor: '#ffffff',
          borderRadius: '16px',
          marginLeft: { xs: '50px', sm: '70px' },
          width: '100%',
          textAlign: 'right',
        }}
      >
        <Typography
          variant="subtitle1"
          color="textSecondary"
          sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' } }}
        >
          {title}
        </Typography>
        <Typography variant="h5" sx={{ fontWeight: 'bold', fontSize: { xs: '1.2rem', sm: '1.5rem' } }}>
          {value}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default StatsCard;